import SXMLink from '@/shared-components/SXMLink';
import dynamic from 'next/dynamic';
import styles from './link.module.scss';
import CallCenterWrapper from '@/components/www/CallCenterWrapper';
import { LinkInfoItem } from '@/components/molecules/LinkInfoCard';
import ChatLink from './ChatLink';
import ImageWrapper from '@/shared-components/ImageWrapper/ImageWrapper';
const Button = dynamic(() => import('de-sxm-reactlib-2/components/atoms/Button/Button'));
const ShowMore = dynamic(() => import('de-sxm-reactlib/components/atoms/ShowMore/ShowMore'));

interface LinkProps {
    asset: SiteLink;
    children?: React.ReactNode;
}

export default function Link({ asset, children }: LinkProps): React.JSX.Element {
    const variant = asset.fields.theme || 'primary';
    const bgColor = asset.fields.ctaColor;

    if (asset.fields.type === 'Chat') {
        return (
            <ChatLink
                type={asset.fields.link_type}
                variant={variant}
                bgColor={bgColor}
                text={asset.fields.link_text}
                iconUrl={asset.fields.media?.url}
                iconWidth={asset.fields.media?.width}
                iconHeight={asset.fields.media?.height}
            />
        );
    } else if (asset.fields.type === 'Manage Cookies') {
        return (
            <SXMLink href="#" className="ot-sdk-show-settings">
                {asset.fields.link_text}
            </SXMLink>
        );
    } else if (asset.fields.type === 'Call Center') {
        let online = <></>;
        let offline = <></>;

        if (asset.fields.link_type === 'LinkInfoCard') {
            online = (
                <LinkInfoItem
                    link={asset.fields as Link}
                    disabled={false}
                    icon={{
                        url: asset.fields.media?.url,
                        width: asset.fields.media?.width,
                        height: asset.fields.media?.height,
                    }}
                />
            );
            offline = (
                <LinkInfoItem
                    link={asset.fields as Link}
                    disabled={true}
                    icon={{
                        url: asset.fields.media?.url,
                        width: asset.fields.media?.width,
                        height: asset.fields.media?.height,
                    }}
                />
            );
        } else {
            online = (
                <ShowMore
                    id="callcenter"
                    showText="Our Call Center is Open"
                    hideText="Our Call Center is Open"
                    activeToggleTextPosition="top"
                    contentClassName={styles.callCenter}
                    shownClassName={styles.show}
                    TagName="span"
                >
                    <SXMLink href={asset.fields.href || ''}>{asset.fields.link_text}</SXMLink>
                </ShowMore>
            );
            offline = <b>Our Call Center is Closed</b>;
        }

        return <CallCenterWrapper online={online} offline={offline} />;
    } else if (asset.fields.link_type === 'Text') {
        const target = asset.fields.type === 'New Tab' ? '_blank' : '_self';
        return (
            <SXMLink
                href={asset.fields.href || ''}
                target={target}
                aria-label={asset.fields.aria_label || asset.fields.link_text}
                inheritParams={asset.fields.inheritParams}
            >
                {asset.fields.media?.url ? (
                    <ImageWrapper
                        src={asset.fields.media.url}
                        alt={asset.fields.media.altText}
                        optimizedHeight={asset.fields.media.height}
                        optimizedWidth={asset.fields.media.width}
                        className={styles.imageWithLink}
                    />
                ) : (
                    asset.fields.link_text
                )}
                {children}
            </SXMLink>
        );
    } else if (asset.fields.link_type && asset.fields.link_type.indexOf('CTA') >= 0) {
        return (
            <Button
                href={asset.fields.href || ''}
                linkTarget={asset.fields.type}
                type="button"
                variant={variant}
                color={bgColor}
                ariaLabel={asset.fields.aria_label || asset.fields.link_text}
                buttonType={asset.fields.type}
                fitting="hug-contents"
                className={variant !== 'tertiary' ? styles.buttonLink : ''}
            >
                {asset.fields.link_text}
            </Button>
        );
    } else if (asset.fields.link_type === 'LinkInfoCard') {
        return (
            <LinkInfoItem
                link={asset.fields as Link}
                disabled={false}
                icon={{
                    url: asset.fields.media?.url,
                    height: asset.fields.media?.height,
                    width: asset.fields.media?.width,
                }}
            />
        );
    }

    return <></>;
}
